import { tracker } from "@openreplay/tracker";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  ACCESS_REQUEST_DETAIL_SEGMENT,
  ACCESS_REQUESTS_ROUTE,
  API_DOCS_ROUTE,
  ASSISTANT_ROUTE,
  CREATE_NEW_JOB_ROUTE,
  DATA_DETAIL_SEGMENT,
  DATA_EXPLORER_ROUTE,
  JOB_DETAIL_SEGMENT,
  JOBS_OVERVIEW_ROUTE,
  JOBS_ROUTE,
  NEW_ACCESS_REQUEST_ROUTE,
  NEW_NOTEBOOKS_ROUTE,
  NOTEBOOKS_ROUTE,
  PERMISSIONS_ROUTE,
} from "./constants";
import { PAGE_NAMES } from "./events";

const PATH_TO_PAGE_NAME: Record<string, string> = {
  "/": PAGE_NAMES.DASHBOARD,
  "": PAGE_NAMES.DASHBOARD,
  [DATA_EXPLORER_ROUTE]: PAGE_NAMES.DATA_EXPLORER,
  [NOTEBOOKS_ROUTE]: PAGE_NAMES.NOTEBOOKS,
  [NEW_NOTEBOOKS_ROUTE]: PAGE_NAMES.NEW_NOTEBOOK,
  [JOBS_ROUTE]: PAGE_NAMES.JOBS,
  [CREATE_NEW_JOB_ROUTE]: PAGE_NAMES.NEW_JOB,
  [JOBS_OVERVIEW_ROUTE]: PAGE_NAMES.OVERVIEW,
  [ASSISTANT_ROUTE]: PAGE_NAMES.ASSISTANT,
  [ACCESS_REQUESTS_ROUTE]: PAGE_NAMES.ACCESS_REQUESTS,
  [NEW_ACCESS_REQUEST_ROUTE]: PAGE_NAMES.NEW_ACCESS_REQUEST,
  [PERMISSIONS_ROUTE]: PAGE_NAMES.PERMISSIONS,
  [API_DOCS_ROUTE]: PAGE_NAMES.API_DOCS,
};

const PATTERN_TO_PAGE_NAME: Array<{ pattern: RegExp; pageName: string }> = [
  {
    pattern: new RegExp(`^${DATA_EXPLORER_ROUTE}/${DATA_DETAIL_SEGMENT}/[^/]+`),
    pageName: PAGE_NAMES.DATA_EXPLORER_DETAILS,
  },
  {
    pattern: new RegExp(`^${JOBS_ROUTE}/${JOB_DETAIL_SEGMENT}/[^/]+`),
    pageName: PAGE_NAMES.JOB_DETAILS,
  },
  {
    pattern: new RegExp(
      `^${ACCESS_REQUESTS_ROUTE}/${ACCESS_REQUEST_DETAIL_SEGMENT}/[^/]+`,
    ),
    pageName: PAGE_NAMES.ACCESS_REQUEST_DETAILS,
  },
];

export function getPageNameFromPath(path: string): string {
  const cleanPath = path.replace(/\/$/, "");

  if (cleanPath in PATH_TO_PAGE_NAME) {
    return PATH_TO_PAGE_NAME[cleanPath];
  }

  for (const { pattern, pageName } of PATTERN_TO_PAGE_NAME) {
    if (cleanPath.match(pattern)) {
      return pageName;
    }
  }

  return PAGE_NAMES.OTHER;
}

export function usePageViewTracking() {
  const location = useLocation();

  useEffect(() => {
    tracker.event(getPageNameFromPath(location.pathname));
  }, [location.pathname]);
}
